import { appConfig } from "../enviroments/enviroment";
import { email_regex } from "../consts/regex";
import axios from "axios";

let button = $("#newsletter_subscribe_button");
let input_field = $("#newsletter_subscribe_field");
let form = $("#newsletter_subscribe_form");
let success_card = $("#newsletter_subscribe_success");
let success_card_close = $("#newsletter_subscribe_success_close");

let email = "";

input_field.on("input focus keyup", function (e) {
  email = e.target.value;

  if (email.endsWith(" ") || email.startsWith(" ")) {
    email = email.replace(" ", "");
  }

  if (!email || !email_regex.test(email)) {
    button.prop("disabled", true);
    button.attr("disabled", true);
    return;
  }

  button.prop("disabled", false);
  button.attr("disabled", false);
});

form.on("submit", function (e) {
  e.preventDefault();
  button.addClass("button--loading");

  const url = `${appConfig.API.URL}/joinNewsletter`;
  const body = {
    email: email,
    mailerTemplateID: "d-8f8c3cf8a1f34f69ba7b871f163a6e5e",
    submitLeadCampaignName: "newsletter",
    source: "footer",
  };

  axios
    .post(url, body, {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": appConfig.API.KEY,
      },
    })
    .then((res) => {
      input_field.val("");
      button.prop("disabled", true);
      button.attr("disabled", true);
      email = "";

      button.removeClass("button--loading");
      success_card.addClass("is-active");
      setTimeout(() => {
        success_card.removeClass("is-active");
      }, 5000);
    })
    .catch((err) => {
      console.log(err);
      button.removeClass("button--loading");
    });
});

success_card_close.on("click", function (e) {
  e.preventDefault();
  success_card.removeClass("is-active");
});
